import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';
import { LandingComponent } from './landing/landing.comp';
import { LoginComponent } from './login/login.comp';

import { ErrorInterceptor } from '@services/error-interceptor';
import { MessageService } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';

import { Amplify } from 'aws-amplify';
import { I18n } from 'aws-amplify/utils';
import { environment } from 'src/environments/environment';

import { AuthInterceptor } from '@services/auth/auth-interceptor';
import { AuthService } from '@services/auth/auth.service';
import { SharedModule } from './shared/shared.module';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { authGuard } from '@services/guards/auth.guard';

I18n.putVocabulariesForLanguage('en', {
  'Given Name': 'Organisation',
  'Enter your Given Name': 'Add your Organisation'
});

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.cognito.userPoolId,
      userPoolClientId: environment.cognito.userPoolWebClientId
    }
  }
});

const routes: Routes = [
  { path: '', component: LandingComponent }, // La nouvelle belle page
  { path: 'login', component: LoginComponent }, // La page d'auth
  {
    path: 'dashboard',
    loadChildren: () => import('./views/views.module').then(m => m.ViewsNemDashboardModule),
    canActivate: [authGuard]
  }
];

@NgModule({
  declarations: [AppComponent, LandingComponent, LoginComponent],
  bootstrap: [AppComponent],
  imports: [BrowserModule, BrowserAnimationsModule, SharedModule, RouterModule.forRoot(routes), MessagesModule],
  providers: [
    MessageService,
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useFactory: (messageService: MessageService) => new ErrorInterceptor(messageService),
      deps: [MessageService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'en-AU' },
    provideHttpClient(withInterceptorsFromDi()),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          prefix: 'p',
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, tailwind-utilities, primeng'
          }
        }
      }
    })
  ]
})
export class AppModule {}
